/**
 * Encryption Keys Configuration
 *
 * SECURITY FIX (#54): Centralizes all encryption key strings used across the application.
 * In production, these keys should be loaded from environment variables to prevent
 * exposure in the JavaScript bundle.
 *
 * NOTE: These keys are symmetric identifiers used for AES-CBC encryption between
 * the frontend and backend. While they appear in the JS bundle, the server must
 * independently validate all requests. For truly sensitive operations, ensure
 * server-side authentication is the primary security layer.
 *
 * To move keys to environment variables, set REACT_APP_ENCRYPTION_KEY_<name>
 * in your .env file. The key will fall back to the hardcoded value if not set.
 */

/**
 * Retrieves an encryption key from environment variables with a hardcoded fallback.
 * @param envKey - The REACT_APP_* environment variable name
 * @param fallback - Default hardcoded value (used if env var is not set)
 * @returns The encryption key string
 */
const getKey = (envKey: string, fallback: string): string => {
	return process.env[envKey] || fallback;
};

// Login encryption key - most sensitive, recommended to move to env variable first
export const LOGIN_ENCRYPTION_KEY = getKey('REACT_APP_LOGIN_KEY', 'UserLoginWebToken');

// Reset password keys
export const RESET_PASSWORD_KEY = getKey('REACT_APP_RESET_PASSWORD_KEY', 'ResetPasswordFromWeb');
export const RESET_FINGERPRINT_KEY = getKey('REACT_APP_RESET_FINGERPRINT_KEY', 'ResetDeviceFingerprintFromWeb');

export default {
	LOGIN_ENCRYPTION_KEY,
	RESET_PASSWORD_KEY,
	RESET_FINGERPRINT_KEY,
};
